module.exports = __webpack_public_path__ + "static/media/haute9D.4333f413.jpg";